import React, { useEffect, useState } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Home from '../pages/HomeScreens/Home';
import EarnBalance from '../pages/HomeScreens/EarnBalance';
import LinkCardStepOne from '../pages/LinkCardLoged/LinkCardStepOne';
import LinkCardStepMB from '../pages/LinkCardLoged/LinkCardStepMB';
import LinkCardStepMbWay from '../pages/LinkCardLoged/LinkCardStepMbWay';
import SeeMovements from '../pages/HomeScreens/SeeMovements';
import PartnersDetails from '../pages/HomeScreens/PartnersDetails';
import OnboardingReferalStepOne from '../pages/OnboardingReferals/OnboardingReferalStepOne';
import OnboardingReferalStepTwo from '../pages/OnboardingReferals/OnboardingReferalStepTwo';
import OnboardingLinkCardStepOne from '../pages/OnboardingLinkingCard/OnboardingLinkCardStepOne';
import OnboardingLinkCardStepMbWay from '../pages/OnboardingLinkingCard/OnboardingLinkCardStepMbWay';
import OnboardingLinkCardStepMB from '../pages/OnboardingLinkingCard/OnboardingLinkCardStepMB';
import PartnersPage from '../pages/HomeScreens/PartnersPage';
import LinkCardStepMbWaySuccessful from '../pages/LinkCardLoged/LinkCardStepMbWaySuccessful';
import OnboardingSteps from '../pages/OnboardingSteps/OnboardingSteps';
import NoMatch from '../pages/NoMatchPage/NoMatch';
import Settings from '../pages/SettingsScreens/Settings';
import NotificationsSettings from '../pages/SettingsScreens/NotificationsSettings';
import AddCardSettings from '../pages/SettingsScreens/AddCardSettings';
import SpendHome from '../pages/HomeScreens/SpendHome';
import DeleteWalletSettings from '../pages/SettingsScreens/DeleteWalletSettings';
import { useDispatch, useSelector } from 'react-redux';
import { setSessionId, setCookieId, setAcceptUserTerms, setSaldoCarteira, setStatusCarteira, setClientId, setHasAccess, setMudaStatusNoti, setNAssocia, setQuantCartoes } from '../features/onboardingData/onboardingUserData';
import { useIsAuthenticated } from '@azure/msal-react';
import { currencyFormat } from '../utils';
import AvailableSoon from '../pages/NoMatchPage/AvailableSoon';
import { errorHandling } from '../utils';
import { useScrollToTop } from '../hooks/useScrollToTop';

const WorkSpaceStack = () => {
  const isSessionId = useSelector((state) => state.onboardingUserData.isSessionId);
  const isCookieId = useSelector((state) => state.onboardingUserData.isCookieId);
  const isAcceptUserTerms = useSelector((state) => state.onboardingUserData.isAcceptUserTerms);
  const isSaldoCarteira = useSelector((state) => state.onboardingUserData.isSaldoCarteira);
  const isStatusCarteira = useSelector((state) => state.onboardingUserData.isStatusCarteira);
  const isHasAccess = useSelector((state) => state.onboardingUserData.isHasAccess);
  const isMudaStatusNoti = useSelector((state) => state.onboardingUserData.isMudaStatusNoti);
  const isNAssocia = useSelector((state) => state.onboardingUserData.isNAssocia);
  const isQuantCartoes = useSelector((state) => state.onboardingUserData.isQuantCartoes);
  const isRefreshGastarSaldo = useSelector((state) => state.onboardingUserData.isRefreshGastarSaldo);
  const [checkSession, setCheckSession] = useState(0)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();

  let location = useLocation();

  useScrollToTop();

  const hadleRedirect = () => {
    window.location.href='https://saude360.medis.pt';
  }; 

  const hadleRedirectOnboarding = () => {
    navigate('/');
  };

  // Express start

  const fetchCSRFToken = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_DEV_URL}/csrf-token`, {
        credentials: "include",
        mode: 'cors'
      });
      const data = await response.json();
      const csrfToken = data.csrfToken;
      return csrfToken;
    } catch (error) {
      errorHandling('CSRF');
    }
  };

  const getSessionId = async () => {
      try {
        const csrfToken = await fetchCSRFToken();
        const response = await fetch(`${process.env.REACT_APP_DEV_URL}/createSession/fetchSessionId`, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'Accept-Language': 'PT-PT',
              'CookieId': `${isCookieId}`,
              "xsrf-token": csrfToken,
          },
          credentials: "include",
          mode: "cors",
          body: JSON.stringify({ originId: "", campaignId: "" }),
        });
        if (response.ok === false) {
          errorHandling(response.status);
          return;
        }
        const result = await response.json();
        dispatch(setSessionId(result.sessionId));
      } catch (error) {
        if (!navigator.onLine) {
          errorHandling('NoInternet');
        } else if (error instanceof TypeError && error.message === "Failed to fetch") {
          errorHandling('CORS');
        } else {
          errorHandling();
        }
      }
  }

  useEffect(() => {
    if ((isAuthenticated && isSessionId === '' && isCookieId !== '') || checkSession === '99') {
      getSessionId(); 
    }
  }, [isAuthenticated, checkSession, isCookieId]);

  const getValidaUmbrella = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_DEV_URL}/validaUmbrella/fetchValidaUmbrella`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept-Language': 'PT-PT',
            'CookieId': `${isCookieId}`,
            'SessionId': `${isSessionId}`,
        },
        credentials: "include",
        mode: "cors",
      });
      if (response.ok === false) {
        errorHandling(response.status);
        return;
      }
      const result = await response.json();
      setCheckSession(result.error.erroCode);
      if (result.error.erroMsg === 'Success') {
        dispatch(setClientId(result.idClient));
        dispatch(setHasAccess(result.client));
        if (result.clienteApaga === true) {
          hadleRedirect();
        }
        if (result.client === false) {
          hadleRedirectOnboarding();
        }
      }
    } catch (error) {
      if (!navigator.onLine) {
        errorHandling('NoInternet');
      } else if (error instanceof TypeError && error.message === "Failed to fetch") {
        errorHandling('CORS');
      } else {
        errorHandling();
      }
    }
  }

  useEffect(() => {
    if (isSessionId !== '' && isCookieId !== '') {
      getValidaUmbrella(); 
    }
  }, [isCookieId, isSessionId, location.pathname]);

  const getInfoGeral = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_DEV_URL}/getInfoGeral/fetchGetInfoGeral`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept-Language': 'PT-PT',
            'CookieId': `${isCookieId}`,
            'SessionId': `${isSessionId}`,
            'nAssocia': `${isNAssocia}`,
        },
        credentials: "include",
        mode: "cors",
      });
      if (response.ok === false) {
        errorHandling(response.status);
        return;
      }
      const result = await response.json();
      if (result.error.erroMsg === 'Success') {
        dispatch(setMudaStatusNoti(result.iStatusNoti == 'S' ? true : false));
        dispatch(setSaldoCarteira(currencyFormat(result.saldoWallet)));
        dispatch(setStatusCarteira(result.statusWallet));
        dispatch(setQuantCartoes(result.quantCartoes));
      }
    } catch (error) {
      if (!navigator.onLine) {
        errorHandling('NoInternet');
      } else if (error instanceof TypeError && error.message === "Failed to fetch") {
        errorHandling('CORS');
      } else {
        errorHandling();
      }
    }
  }

  useEffect(() => {
    if (isHasAccess || isAcceptUserTerms) {
      getInfoGeral(); 
    }
  }, [isHasAccess, isAcceptUserTerms, isRefreshGastarSaldo, location.pathname]);

  // Express end

  return (
      <Routes>
          { ( isHasAccess || isAcceptUserTerms) ? (
              <>
              <Route path="/" element={<Home />} />
              <Route path="/ganhar-saldo" element={<EarnBalance />} />
              <Route path="/ganhar-saldo/parceiros" element={<EarnBalance />} />
              <Route path="/ganhar-saldo/parceiros/catalogo-de-parceiros" element={<PartnersPage />} />
              <Route path="/ganhar-saldo/parceiros/catalogo-de-parceiros/:categoryStore" element={<PartnersDetails />} />
              <Route path="/configuracoes" element={<Settings />} />
              <Route path="/configuracoes/notificacoes" element={<NotificationsSettings />} />
              <Route path="/configuracoes/associar-cartao" element={<AddCardSettings />} />
              <Route path="/configuracoes/desligar-carteira" element={<DeleteWalletSettings />} />
              <Route path="/configuracoes/associar-cartao/com-sucesso" element={<LinkCardStepMbWaySuccessful />}/>  
              <Route path="/configuracoes/associar-cartao/tipo-de-associacao" element={<LinkCardStepOne />} />
              <Route path="/configuracoes/associar-cartao/mbway" element={<LinkCardStepMbWay />} />
              <Route path="/configuracoes/associar-cartao/multibanco" element={<LinkCardStepMB />} />
              <Route path="/ativar-carteira-virtual" element={<OnboardingReferalStepOne />} />
              <Route path="/ativar-carteira-virtual/associar-cartao" element={<OnboardingReferalStepTwo />} />
              <Route path="/ativar-carteira-virtual/associar-cartao/tipo-de-associacao" element={<OnboardingLinkCardStepOne />} />
              <Route path="/ativar-carteira-virtual/associar-cartao/mbway" element={<OnboardingLinkCardStepMbWay />} />
              <Route path="/ativar-carteira-virtual/associar-cartao/multibanco" element={<OnboardingLinkCardStepMB />} />
              <Route path="/movimentos" element={<SeeMovements />} />
              { (isStatusCarteira !== '2') &&
                <>
                <Route path="/ganhar-saldo/ofertas" element={<EarnBalance />} />
                <Route path="/ganhar-saldo/convidar-amigos" element={<EarnBalance />} />
                <Route path="/gastar-saldo" element={<SpendHome/>} />
                <Route path="/gastar-saldo/seguro" element={<SpendHome/>} />
                <Route path="/gastar-saldo/marketplace" element={<SpendHome/>} />
                </>
              }
              { (isStatusCarteira === '2') &&
                <>
                <Route path="/ganhar-saldo/ofertas" element={<Home />} />
                <Route path="/ganhar-saldo/convidar-amigos" element={<Home />} />
                <Route path="/gastar-saldo" element={<Home/>} />
                <Route path="/gastar-saldo/seguro" element={<Home/>} />
                <Route path="/gastar-saldo/marketplace" element={<Home/>} />
                </>
              }
          </>
          ) : (
              <>
                <Route path="/" element={<OnboardingSteps />}/>
                <Route path="/ganhar-saldo" element={<OnboardingSteps />} />
                <Route path="/ganhar-saldo/parceiros" element={<OnboardingSteps />} />
                <Route path="/ganhar-saldo/ofertas" element={<OnboardingSteps />} />
                <Route path="/ganhar-saldo/convidar-amigos" element={<OnboardingSteps />} />
                <Route path="/ganhar-saldo/parceiros/catalogo-de-parceiros" element={<OnboardingSteps />} />
                <Route path="/ganhar-saldo/parceiros/catalogo-de-parceiros/:categoryStore" element={<OnboardingSteps />} />
                <Route path="/configuracoes" element={<OnboardingSteps />} />
                <Route path="/configuracoes/notificacoes" element={<OnboardingSteps />} />
                <Route path="/configuracoes/associar-cartao" element={<OnboardingSteps />} />
                <Route path="/configuracoes/desligar-carteira" element={<OnboardingSteps />} />
                <Route path="/configuracoes/associar-cartao/com-sucesso" element={<OnboardingSteps />}/>  
                <Route path="/configuracoes/associar-cartao/tipo-de-associacao" element={<OnboardingSteps />} />
                <Route path="/configuracoes/associar-cartao/mbway" element={<OnboardingSteps />} />
                <Route path="/configuracoes/associar-cartao/multibanco" element={<OnboardingSteps />} />
                <Route path="/ativar-carteira-virtual" element={<OnboardingSteps />} />
                <Route path="/ativar-carteira-virtual/associar-cartao" element={<OnboardingSteps />} />
                <Route path="/ativar-carteira-virtual/associar-cartao/tipo-de-associacao" element={<OnboardingSteps />} />
                <Route path="/ativar-carteira-virtual/associar-cartao/mbway" element={<OnboardingSteps />} />
                <Route path="/ativar-carteira-virtual/associar-cartao/multibanco" element={<OnboardingSteps />} />
                <Route path="/movimentos" element={<OnboardingSteps />} />
                <Route path="/gastar-saldo/seguro" element={<OnboardingSteps/>} />
                <Route path="/gastar-saldo/marketplace" element={<OnboardingSteps/>} />
              </>

          )}
          <Route path="*" element={<NoMatch />} />
      </Routes>
  );
};

export default WorkSpaceStack;
